import type { Locale } from "./config";
import { DEFAULT_LOCALE } from "./config";

export type Messages = Record<string, string>;

const loaders: Record<Locale, () => Promise<{ default: Messages }>> = {
  en: () => import("@/locales/en.json"),
  es: () => import("@/locales/es.json"),
  ca: () => import("@/locales/ca.json"),
  de: () => import("@/locales/de.json"),
  fr: () => import("@/locales/fr.json"),
  it: () => import("@/locales/it.json"),
  pt: () => import("@/locales/pt.json"),
};

export const loadMessages = async (locale: Locale) => {
  if (locale === DEFAULT_LOCALE) {
    const { default: messages } = await loaders[locale]();
    return messages;
  }

  const [{ default: base }, { default: localized }] = await Promise.all([
    loaders[DEFAULT_LOCALE](),
    loaders[locale](),
  ]);

  return { ...base, ...localized };
};
